import { useQuery } from "@tanstack/react-query";

import type { IWebsiteAnalysisTrafficRequestParams } from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

interface IWebRanksResponse {
    Data: Array<{
        Domain: string;
        Favicon: string;
        Rank: number;
    }>;
    TotalCount: number;
    Header: Record<string, string>;
}

export const useWebRanksData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    controller: string,
    { enabled = true }: { enabled?: boolean } = {},
) => {
    return useQuery<IWebRanksResponse>({
        queryKey: ["webRanks", params, controller],
        queryFn: () => WebsiteAnalysisApiService.getInstance().getWebRanksDataForWebsitePerformance(params, controller),
        enabled,
    });
};
